import Vue from 'vue'
import VueRouter from 'vue-router';
import Listing from './components/Listing.vue';
import SceneOverview from './components/Sceneoverview.vue';
import SceneDetail from './components/SceneDetail.vue';
import SceneVideo from './components/SceneVideo.vue';
import SceneInteractive from './components/SceneInteractive.vue'

Vue.use(VueRouter);

export const router = new VueRouter({
  routes: [
    {
      path: '/:lang/',
      component: Listing
    },
    {
      path: '/:lang/:scenedetail',
      component: SceneOverview,
      children: [
        {
          path: '',
          component: SceneDetail,
          name: 'sceneDetail'
        },
        {
          path: 'virtual-tour',
          component: SceneVideo,
          name: 'Guided Tour',
          alias: [
            'guided-tour',
            'visita-guidata'
          ]
        },
        {
          path: 'interactive',
          component: SceneInteractive,
          name: 'interactive',
          alias: [
            'interactive-3d-mode',
            'modalita-3d-interattiva'
          ]
        },
        {
          path: 'close-up',
          component: SceneInteractive,
          name: 'Close Up',
          children: [
            {
              path: ':product',
              component: SceneInteractive,
              name: 'Product'
            }
          ]
        }
      ]
    },
    {
      path: '/:lang/catalogue',
      component: SceneInteractive,
      name: 'catalogue',
      alias: [
        'catalogue',
        'catalogo'
      ],
      children: [
        {
          path: ':photometric',
          component: SceneInteractive,
          name: 'Photometric'
        }
      ]
    }
  ],
  mode: 'history'
});



// WEBPACK FOOTER //
// ./src/routes.js